import { lazy } from 'react';

const OrganisationTypeRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "OrganisationType" */ '../components/steps/organisation-type-step/OrganisationType'
    ),
);

export default OrganisationTypeRoute;
